import { useEffect } from "react"

import { createFileRoute, Navigate } from "@tanstack/react-router"

import { CompanyFlowContext } from "@/lib/flows/company"

export const Route = createFileRoute("/_dashboard/company/")({
  component: RouteComponent,
})

function RouteComponent() {
  const flowActorRef = CompanyFlowContext.useActorRef()
  useEffect(() => {
    // If the user navigates to the index /company route, we reset the flow
    // state so they go to the first step of the flow.
    flowActorRef.send({ type: "reset" })
  }, [])

  return <Navigate to="/company/details" />
}
